// Allow the user to customize the Promise type returned by this library.
var mypromise = global.Promise;
module.exports = function getOrSetPromise(p) {
    if (p) { mypromise = p; }
    return mypromise;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_pn@1.1.0@pn/_promise.js
// module id = 056L
// module chunks = 0